import { withStyles } from '@material-ui/core';
import styles from './PromoInfo.styles';
import PromoInfo from './PromoInfo';

export default withStyles(styles)(PromoInfo);
